import { Injectable } from '@angular/core';
import { LpWk8BookSentence, LpWk8BookSentencePartFilter } from '@typings/lp/generated';

@Injectable({
  providedIn: 'root',
})
export class Wk8GlobalsService {
  public currentLevel: undefined | { sentence: LpWk8BookSentence; part: LpWk8BookSentencePartFilter };
}
